import { PayloadAction } from '@reduxjs/toolkit';
import { CategoryState } from '../types';

const toggleActiveCategoriesReducer = (
  state: CategoryState,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  action: PayloadAction<number>,
) => {
  if (state.activeCategories?.includes(action.payload)) {
    state.activeCategories = state.activeCategories.filter((item) => item !== action.payload);
  } else {
    state.activeCategories = [...state.activeCategories, action.payload];
  }
};

export default toggleActiveCategoriesReducer;
